import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0f0805] py-8 border-t border-[#c9923f]/10">
      <div className="container mx-auto px-6 lg:px-12">
        {/* <p className="text-center text-white/40 text-xs mb-4 max-w-2xl mx-auto leading-relaxed">
          Manufacturer of bakery machines, ovens, mixers, conveyors, slicers
          since 1992.
        </p> */}
        <div className="text-center text-white/60 text-sm">
          © {currentYear} Rahul Engineering Works. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
